
export const root = {
    background: '{dropdown.background}',
    borderColor: '{dropdown.border.color}',
    color: '{dropdown.color}',
    borderRadius: '{dropdown.border.radius}',
    shadow: '{dropdown.shadow}',
    transitionDuration: '{transition.duration}',
    padding: '{dropdown.padding}',
    minWidth: '{dropdown.min.width}'
};

export const list = {
    padding: '{navigation.list.padding}',
    gap: '{navigation.list.gap}'
};

export const item = {
    focusBackground: '{dropdown.item.focus.background}',
    color: '{dropdown.item.color}',
    focusColor: '{dropdown.item.focus.color}',
    padding: '{dropdown.item.padding}',
    borderRadius: '{dropdown.item.border.radius}',
    gap: '{dropdown.item.gap}',
    fontSize: '0.875rem',
    icon: {
        color: '{dropdown.item.icon.color}',
        focusColor: '{dropdown.item.icon.focus.color}',
        size: '0.875rem'
    }
};

export const submenuLabel = {
    padding: '{navigation.submenu.label.padding}',
    fontWeight: '{navigation.submenu.label.font.weight}',
    background: '{navigation.submenu.label.background}',
    color: '{navigation.submenu.label.color}'
};

export const separator = {
    borderColor: '{dropdown.separator.border.color}',
    margin: '{dropdown.separator.margin}'
};

export const colorScheme = {
    light: {
        item: {
            hoverBackground: '{dropdown.item.hover.background}',
            hoverColor: '{dropdown.item.hover.color}'
        }
    },
    dark: {
        item: {
            hoverBackground: '{dropdown.item.hover.background}',
            hoverColor: '{dropdown.item.hover.color}'
        }
        // root styling now inherited from {dropdown.*} tokens in base theme
    }
};

// Menu CSS inherits font-size from parent (no dt() call) — force via css callback
export const css = ({dt}: {dt: (token: string) => string}) => `
.p-menu {
    font-size: 0.875rem;
}
`;

export default {
    root,
    list,
    item,
    submenuLabel,
    separator,
    colorScheme,
    css
};
